export enum EngagementTrigger {
    Start = 0,
    End = 1,
}
